import BrandingJSON from './brandingJSON';
import tabJSON from './tabJSON';
var AAConfig:any={
    connectionDetails : {},
    container: 'aa-web-sdk-window',
    branding: BrandingJSON,
    dskSettings : tabJSON
};

export default AAConfig;